var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { type: "primary" } },
    [
      _c(
        "div",
        { staticClass: "grid-view" },
        [
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _c(
                "search-item",
                {
                  attrs: {
                    "config-module": "2401",
                    reset: true,
                    "custom-sim-query-placeholder":
                      _vm.$t("Clearing.QuickRetrieval") +
                      _vm.$t("SystemMaintenance.TemplateName"),
                    "custom-search-items": _vm.customSearchItems
                  },
                  on: {
                    "click-more": function(value) {
                      return (_vm.isAdvancedQuery = value)
                    },
                    simSearchItemCallBack: _vm.toSimpleQuery,
                    advSearchItemCallBack: _vm.toAdvancedQuery
                  }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "operations" }, slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "look",
                            disabled: _vm.isEnable,
                            type: "success"
                          },
                          on: {
                            click: function($event) {
                              return _vm.toLook()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                      ),
                      _vm.$checkPermission([
                        "button_DocumentTemplateManagement_edit"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "Edit",
                                disabled: _vm.isEnable,
                                type: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toEdit()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_DocumentTemplateManagement_edit"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "new", type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.toAdd()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_DocumentTemplateManagement_edit"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "enable",
                                disabled: _vm.isEnableDisabled,
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toEnable()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Enable")))]
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_DocumentTemplateManagement_edit"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "disable",
                                disabled: _vm.isDisableDisabled,
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toDisable()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Disable")))]
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "button_DocumentTemplateManagement_edit"
                      ])
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "Delete",
                                disabled: _vm.isDeleteDisabled,
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toDelete()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "config-module": "2400052",
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "side-bar": {
                        toolPanels: ["columns", "filter"],
                        visible: false
                      }
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: _vm.onGridReady
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    attrs: {
                      "config-module": "24000523",
                      total: _vm.filter.total,
                      "page-count": _vm.pageCount,
                      page: _vm.filter.pageNum,
                      limit: _vm.filter.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.filter, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(_vm.filter, "pageSize", $event)
                      },
                      pagination: _vm.toQuery
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("pre-view-file-dialog", {
            attrs: {
              "v-if": _vm.previewFileData.visible,
              no: "preview",
              title: _vm.$t("FileHistory.preview"),
              visible: _vm.previewFileData.visible,
              file: _vm.previewFileData.file,
              "can-maximize": true
            },
            on: { close: _vm.closePreviewDialog }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }